module.exports = __webpack_public_path__ + "img/5565d66a50b44df9ae37a955bdfb3757.7ab0bb66.png";